/**
 * Reveals PDP buybox when productBuyBox is ready. Yotpo review rows reveal independently when stable.
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) {
    document.querySelectorAll('[data-pdp-buybox-shell]').forEach(function (shell) {
      shell.classList.remove('is-loading');
      shell.classList.add('is-ready');
    });
    document.querySelectorAll('[data-pdp-gallery-shell]').forEach(function (shell) {
      shell.classList.remove('is-loading');
      shell.classList.add('is-ready');
    });
    document.querySelectorAll('[data-pdp-yotpo-rating-wrap]').forEach(function (wrap) {
      wrap.classList.add('is-stable');
      wrap.removeAttribute('aria-hidden');
    });
    document.documentElement.classList.add('pdp-buybox-loaded');
    return;
  }

  var shells = document.querySelectorAll('[data-pdp-buybox-shell]');
  if (!shells.length && !document.querySelector('[data-pdp-gallery-shell]')) return;

  function applyFinalStyles() {
    if (typeof window.pdpApplyFinalSalePriceStyles === 'function') {
      window.pdpApplyFinalSalePriceStyles();
    }
    if (typeof window.pdpApplyFinalSalePriceLabel === 'function') {
      window.pdpApplyFinalSalePriceLabel();
    }
    if (typeof window.updateFinalSaleLabel === 'function') {
      window.updateFinalSaleLabel();
    }
  }

  function isBuyboxReady() {
    var pb = window.eHS && window.eHS.productBuyBox;
    return !!(pb && pb.product && pb.currentVariant);
  }

  function hasYotpoRatingContent(wrap) {
    var starSelector =
      '.yotpo-icon-star, .yotpo-icon-half-star, .yotpo-icon-empty-star, ' +
      '.yotpo-sr-star-full, .yotpo-sr-star-half, .star-container, .yotpo-stars, ' +
      '.yotpo-sr-star-rating, .yotpo-reviews-star-ratings-widget, .yotpo-sr-bottom-line-text, ' +
      '.yotpo-bottom-line-score, .yotpo-bottom-line-text, a.text-m';

    if (wrap.querySelector(starSelector)) return true;

    var bottomLine = wrap.querySelector('.yotpo.bottomLine, .yotpo-bottomline, .yotpo-widget-instance');
    if (bottomLine && bottomLine.querySelector(starSelector)) return true;

    var text = (wrap.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length > 0;
  }

  function yotpoAssetsSettled(wrap) {
    if (!hasYotpoRatingContent(wrap)) return false;

    var imgs = wrap.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete || imgs[i].naturalWidth === 0) return false;
    }

    return true;
  }

  function markYotpoWrapStable(wrap) {
    if (!wrap || wrap.classList.contains('is-stable')) return;
    wrap.classList.add('is-stable');
    wrap.removeAttribute('aria-hidden');
  }

  function resetYotpoWrapsForReveal() {
    document.querySelectorAll('[data-pdp-yotpo-rating-wrap]').forEach(function (wrap) {
      wrap.classList.remove('is-stable');
      wrap.setAttribute('aria-hidden', 'true');
      delete wrap.dataset.pdpYotpoStabilityInit;
    });
  }

  function initYotpoRatingStability() {
    document.querySelectorAll('[data-pdp-yotpo-rating-wrap]').forEach(function (wrap) {
      if (wrap.dataset.pdpYotpoStabilityInit === 'true') return;
      wrap.dataset.pdpYotpoStabilityInit = 'true';

      var stableTimer = null;
      var done = false;
      var observer = null;
      var QUIET_MS = 400;

      function finishStable() {
        if (done) return;
        done = true;
        if (observer) observer.disconnect();
        clearTimeout(stableTimer);
        markYotpoWrapStable(wrap);
      }

      function canMarkStable() {
        return hasYotpoRatingContent(wrap) && yotpoAssetsSettled(wrap);
      }

      function scheduleStableCheck() {
        if (done) return;
        clearTimeout(stableTimer);

        stableTimer = setTimeout(function () {
          if (done) return;
          if (!canMarkStable()) {
            scheduleStableCheck();
            return;
          }

          // Two frames to confirm layout is painted before reveal (no extra delay).
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              if (done) return;
              if (!canMarkStable()) {
                scheduleStableCheck();
                return;
              }
              finishStable();
            });
          });
        }, QUIET_MS);
      }

      function forceStable() {
        if (done) return;
        if (!hasYotpoRatingContent(wrap)) return;
        finishStable();
      }

      observer = new MutationObserver(scheduleStableCheck);
      observer.observe(wrap, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });

      scheduleStableCheck();
      setTimeout(forceStable, 5000);

      if (window.yotpo && typeof window.yotpo.ready === 'function') {
        window.yotpo.ready(scheduleStableCheck);
      } else {
        var yotpoAttempts = 0;
        var yotpoPoll = setInterval(function () {
          yotpoAttempts += 1;
          if (window.yotpo && typeof window.yotpo.ready === 'function') {
            clearInterval(yotpoPoll);
            window.yotpo.ready(scheduleStableCheck);
          } else if (yotpoAttempts > 80) {
            clearInterval(yotpoPoll);
          }
        }, 100);
      }
    });
  }

  function onDataReady() {
    applyFinalStyles();
    setTimeout(function () {
      applyFinalStyles();
      document.dispatchEvent(new CustomEvent('pdp:buyboxDataReady'));
    }, 150);
  }

  function waitForReady() {
    if (isBuyboxReady()) {
      onDataReady();
      return;
    }

    var attempts = 0;
    var poll = setInterval(function () {
      attempts += 1;
      if (isBuyboxReady()) {
        clearInterval(poll);
        onDataReady();
      } else if (attempts > 160) {
        clearInterval(poll);
        document.dispatchEvent(new CustomEvent('pdp:buyboxDataReady'));
      }
    }, 50);
  }

  document.addEventListener('pdp:buyboxRevealed', function () {
    resetYotpoWrapsForReveal();

    if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
      try {
        window.yotpo.refreshWidgets();
      } catch (e) {}
    }

    initYotpoRatingStability();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForReady);
  } else {
    waitForReady();
  }

  setTimeout(function () {
    if (!document.documentElement.classList.contains('pdp-buybox-loaded')) {
      document.dispatchEvent(new CustomEvent('pdp:buyboxDataReady'));
    }
  }, 10000);
})();
